import { parentesco } from '@utils';
import {
  certidaoGenitor,
  childs,
  commons,
  death,
  menorTutela,
  others,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const ContConjulgadaFinDocs = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCertidaoNascimento: dynamicRule('required'),
    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoTermoTutelaJudicial: dynamicRule('menorTutela'),
    anexoOutros: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...death, ...childs],
    others: [...others],
    [constants.FILHO]: [],
    [constants.ENTEADO]: [...certidaoGenitor],
    [constants.MENOR_TUTELA]: [...menorTutela],
    'Menor sob tutela(a)': [...menorTutela],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
